/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Stocktake_Morning_HelpInputs */

const vi_stocktake_morning_help = /** @type {(inputs: Stocktake_Morning_HelpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hệ thống sẽ tự chụp state kho khi bấm 'Tạo phiếu'. Kiểm sáng thuộc cycle ngày ${i?.date}.`)
};

/**

* @param {Stocktake_Morning_HelpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_morning_help = /** @type {((inputs: Stocktake_Morning_HelpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Morning_HelpInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_morning_help(inputs)
});